export default __webpack_public_path__ + "static/media/Icon-vertical-menu.49ea1a43.svg";